import { SortOrder } from '@shared/models/filter-sort';
import { AffordabilityMet, OutcomeResults, YesNoResults } from '@shared/models/enums';

export interface IIgniteFilterOption {
  lenderName?: any[] | null;
  affordabilityMatched?: AffordabilityMet;
  igniteResultsOrder?: SortOrder;
  outcomeResult?: OutcomeResults;
  propertyResult?: OutcomeResults;
  productsMatched?: YesNoResults;
}

export enum FilterKey {
  LenderName = 'lenderName',
  AffordabilityMatched = 'affordabilityMatched',
  IgniteResultsOrder = 'igniteResultsOrder',
  OutcomeResult = 'outcomeResult',
  PropertyResult = 'propertyResult',
  ProductsMatched = 'productsMatched',
}
